module.exports = __webpack_public_path__ + "img/model6.0ea63222.png";